module.exports = __webpack_public_path__ + "img/7.66ed6d7b.jpg";